import React, { useEffect, forwardRef } from 'react'

const FormFieldEntry = (props, innerRef) => {
    useEffect(() => {
        if (props.typeOfEnclosing === "gz-radio-group" || props.typeOfEnclosing === "gz-time-picker" || props.typeOfEnclosing === "gz-input-number") {
            return;
        }

        const enclosingType = props.typeOfEnclosing === "gz-single-select"
            ? `${props.formFieldId}_select` : (props.typeOfEnclosing === "gz-input" ? `${props.formFieldId}_input` : `${props.formFieldId}_checkbox`);

        const formFieldElement = document.getElementById(enclosingType);

        if (props.typeOfEnclosing === "gz-checkbox") {
            if (props.isChecked) {
                formFieldElement.checked = true;
            } else {
                formFieldElement.checked = false;
            }
        }
        if (props.value !== '' || props.value !== 'undefined' || props.value !== null) {
            formFieldElement.value = props.value;
        }
    });

    switch (props.typeOfEnclosing) {
        case "gz-single-select":
            return (
                <>
                    <gz-form-field label={props.label} id={props.formFieldId} ref={innerRef}>
                        <gz-single-select
                            id={`${props.formFieldId}_select`}
                            gz-form-input
                            labelWidth={props.width ? props.width : '160'}
                            placeholder={props.placeholder}
                            filterOptions={JSON.stringify(props.filterOptions)}
                            {...(props.disableCondition ? { disabled: true } : {})}
                        ></gz-single-select>
                        <gz-input-error></gz-input-error>
                    </gz-form-field>
                    {props.description && <div className='mb-4 w-800'>
                        <gz-text fontSize="12">
                            {props.description}
                        </gz-text>
                    </div>}
                </>)
        case "gz-input":
            if (props.readonly) {
                return (
                    <gz-form-field label={props.label} id={props.formFieldId} ref={innerRef} readonly>
                        <gz-input
                            id={`${props.formFieldId}_input`}
                            gz-form-input
                            inputWidth={props.width ? props.width : '160'}
                            placeholder={props.placeholder}
                            type={props.type === 'password' ? 'password' : 'text'}
                            {...(props.disableCondition ? { disabled: true } : {})}
                        />
                        <gz-input-error></gz-input-error>
                    </gz-form-field>
                )
            }

            return (
                <gz-form-field label={props.label} id={props.formFieldId} ref={innerRef}>
                    <gz-input
                        id={`${props.formFieldId}_input`}
                        gz-form-input
                        type={props.type === 'password' ? 'password' : 'text'}
                        inputWidth={props.width ? props.width : '160'}
                        placeholder={props.placeholder}
                        {...(props.disableCondition ? { disabled: true } : {})}
                    />
                    <gz-input-error></gz-input-error>
                </gz-form-field>
            )

        case "gz-checkbox":
            return (
                <gz-form-field id={props.formFieldId} ref={innerRef} >
                    <gz-checkbox
                        id={`${props.formFieldId}_checkbox`}
                        gz-form-input
                        errortooltiptext
                        color="primary"
                        label={props.label}
                        {...(props.disableCondition ? { disabled: true } : {})}
                    />
                    <gz-input-error></gz-input-error>
                </gz-form-field>
            )

        case "gz-time-picker":
            return (
                <gz-form-field id={props.formFieldId} label={props.label} ref={innerRef}>
                    <gz-time-picker gz-form-input />
                    <gz-input-error></gz-input-error>
                </gz-form-field>
            )

        case "gz-input-number":
            return (
                <gz-form-field id={props.formFieldId} label={props.label} ref={innerRef}>
                    <gz-input-number gz-form-input />
                    <gz-input-error></gz-input-error>
                </gz-form-field>
            )

        case "gz-radio-group":
            return (
                <gz-form-field id={props.formFieldId}>
                    <gz-radio-group ref={innerRef} gz-form-input {...(props.disableCondition ? { disabled: true } : {})}>
                        {
                            props.value.map((item, i) => {
                                return (
                                    <div key={i} className='mb-4'>
                                        <gz-radio value={item.value} label={item.label}></gz-radio>
                                        <div className='ml-6'>
                                            <gz-text fontSize="12">
                                                {item.description}
                                            </gz-text>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </gz-radio-group>
                    <gz-input-error></gz-input-error>
                </gz-form-field>
            )

        default:
            break;
    }
}

export default forwardRef(FormFieldEntry)